import * as yup from 'yup';

export const schema = yup.object().shape({
  Email: yup.string()
    .email('Informe um e-mail válido')
    .required('Informe seu email'),
  Senha: yup.string()
    .required('Informe sua senha')
});
